import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '@/components/ui/button';
import { ArrowLeft, LogOut } from 'lucide-react';
import SimulateurMargesPhysique from '@/components/simulateurs/SimulateurMargesPhysique';

const SESSION_KEY = 'admin_authenticated';

export default function AdminSimulateurMargesPhysique() {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY) !== 'true') {
      navigate('/admin');
    }
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem(SESSION_KEY);
    navigate('/admin');
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Simulateur Marges Physique - Cosmos Wave</title>
      </Helmet>
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-between items-center mb-8">
            <Button variant="ghost" asChild>
              <Link to="/admin/simulateurs">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Retour aux simulateurs
              </Link>
            </Button>
            <Button variant="outline" onClick={handleLogout}>
              <LogOut className="w-4 h-4 mr-2" />
              Déconnexion
            </Button>
          </div>

          <SimulateurMargesPhysique />
        </div>
      </div>
    </>
  );
}
